import {defineStore} from 'pinia';
import {authService} from '@/modules/auth/services/auth-service';
import {
    hasAnyRole,
    MARKET_ROLES,
    ADMIN_ROLES,
    OPS_ROLES,
    ROLES,
    COMMERCIAL_ROLES,
    FINANCE_ROLES
} from '@/utils/roles';
import {useCommissionStore} from '@/modules/commission/stores/use-commission-store';
import {useDashboardStore} from '@/modules/dashboard/stores/use-dashboard-store';
import {clearAllApiCache} from '@/utils/cache';

export const useAuthStore = defineStore('auth-store', {
    state: () => ({
        user: null,
        loading: false,
    }),

    getters: {
        isAuthenticated: (state) => !!state.user,
        isSuperAdmin: (state) => hasAnyRole([ROLES.SUPER_ADMIN], state.user),
        isAdmin: (state) => hasAnyRole(ADMIN_ROLES, state.user),
        isFieldRole: (state) => hasAnyRole(MARKET_ROLES, state.user),
        isFinanceRole: (state) => hasAnyRole(FINANCE_ROLES, state.user),
        isCommercialRole: (state) => hasAnyRole(COMMERCIAL_ROLES, state.user),
        isOpsRole: (state) => hasAnyRole(OPS_ROLES, state.user),
    },

    actions: {
        async fetchMe() {
            const {data} = await authService.me();
            this.user = data;
            return data;
        },

        async logout() {
            await authService.logout().catch(() => {});
            this.user = null;
            useCommissionStore().$reset();
            useDashboardStore().$reset();
            await clearAllApiCache();
        },

        async handleSessionExpired() {
            this.user = null;
            useCommissionStore().$reset();
            useDashboardStore().$reset();
            await clearAllApiCache();
        },
    },
});
